export default __webpack_public_path__ + "static/media/bgt.16ba6b88.png";